package com.bikompanion.data

internal actual fun logNetwork(
    tag: String,
    message: String,
) {
    console.log("$NETWORK_LOG_TAG [$tag] $message")
}
